import { render, staticRenderFns } from "./Proprietary.vue?vue&type=template&id=cbf5cddc&scoped=true&"
import script from "./Proprietary.vue?vue&type=script&lang=js&"
export * from "./Proprietary.vue?vue&type=script&lang=js&"
import style0 from "./Proprietary.vue?vue&type=style&index=0&id=cbf5cddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf5cddc",
  null
  
)

export default component.exports